<template>
  <div class="progress-bar">
    <div class="progress-line">
      <div
        class="progress-fill"
        :style="{ width: progressWidth }"
      ></div>
    </div>
    <div class="progress-steps">
      <div
        v-for="(step, index) in steps"
        :key="index"
        class="progress-step"
        :class="{
          active: currentStep >= index,
          completed: currentStep > index
        }"
      >
        <div class="step-circle">
          <span v-if="currentStep > index" class="check-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </span>
          <span v-else>{{ index + 1 }}</span>
        </div>
        <span class="step-label">{{ step }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    currentStep: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array,
      default: () => ['校验卡密', '校验Token', '确认提交']
    }
  },
  computed: {
    progressWidth() {
      if (this.currentStep <= 0) return '0%'
      const progress = (this.currentStep / (this.steps.length - 1)) * 100
      return `${Math.min(progress, 100)}%`
    }
  }
}
</script>

<style scoped>
.progress-bar {
  position: relative;
  padding: 28px 12px 8px;
}

.progress-steps {
  display: flex;
  justify-content: space-between;
  position: relative;
  z-index: 2;
}

.progress-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
}

.step-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: var(--ios-card);
  border: 2px solid rgba(120, 120, 128, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 600;
  color: var(--ios-label-secondary);
  transition: all 0.3s ease;
}

.progress-step.active .step-circle {
  background: var(--ios-blue);
  border-color: var(--ios-blue);
  color: #fff;
  box-shadow: 0 2px 8px rgba(0, 122, 255, 0.35);
}

.progress-step.completed .step-circle {
  background: var(--ios-green);
  border-color: var(--ios-green);
  color: #fff;
  box-shadow: none;
}

.check-icon {
  display: flex;
}

.check-icon svg {
  width: 17px;
  height: 17px;
}

.step-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--ios-label-tertiary);
  transition: color 0.3s ease;
}

.progress-step.active .step-label {
  color: var(--ios-blue);
}

.progress-step.completed .step-label {
  color: var(--ios-label-secondary);
}

.progress-line {
  position: absolute;
  top: 44px;
  left: calc(12px + 16.66%);
  right: calc(12px + 16.66%);
  height: 3px;
  background: rgba(120, 120, 128, 0.2);
  border-radius: 100px;
  z-index: 1;
}

.progress-fill {
  height: 100%;
  background: var(--ios-blue);
  border-radius: inherit;
  transition: width 0.4s ease;
}

@media (max-width: 600px) {
  .progress-bar {
    padding: 18px 8px 6px;
  }

  .step-circle {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }

  .progress-line {
    top: 31px;
  }

  .step-label {
    font-size: 11px;
  }
}
</style>
